const mixin = {
  computed: {
    currentStudentId () {
      return this.$route.params.id
    }
  }
}

export default mixin
